export default __webpack_public_path__ + "static/media/gallery27.fa790c33.jpg";